import React from 'react';
import style from './features.module.scss';
import classNames from 'classnames';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';

interface FeatureOwnProps {
    icon: JSX.Element;
    title: FormattedMessage.MessageDescriptor;
    text: FormattedMessage.MessageDescriptor;
}

type FeatureProps = InjectedIntlProps & FeatureOwnProps;

export enum FeaturesWideLayout {
    // 1 │ 2
    // ──┼──
    // 3 │ 4
    TwoRows,

    // 1 │ 3
    // ──┼──
    // 2 │ 4
    TwoColumns,

    FourColumns
}

interface FeaturesProps {
    layout: FeaturesWideLayout;
    feature1: FeatureOwnProps;
    feature2: FeatureOwnProps;
    feature3: FeatureOwnProps;
    feature4: FeatureOwnProps;
}

const FeaturePresentational: React.FC<FeatureProps> = ({intl, icon, title, text}) => (
    <div className={style.featureContainer}>
        {icon}
        <span className={style.featureTitle}>{intl.formatMessage(title)}</span>
        <span className={style.featureText}>{intl.formatMessage(text)}</span>
    </div>
);

const Feature = injectIntl(FeaturePresentational);

export const Features: React.FC<FeaturesProps> = props => {
    return (
        <div
            className={classNames(style.featuresContainer, {
                [style.twoRows]: props.layout === FeaturesWideLayout.TwoRows,
                [style.fourColumns]: props.layout === FeaturesWideLayout.FourColumns
            })}
        >
            <div className={style.featuresGroup}>
                <Feature {...props.feature1} />
                <Feature {...props.feature2} />
            </div>
            <div className={style.featuresGroup}>
                <Feature {...props.feature3} />
                <Feature {...props.feature4} />
            </div>
        </div>
    );
};
